module.exports = "<p>\n  syncwithcognos works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/bi-reporting-config/syncwithcognos/syncwithcognos.component.html
// module id = ../../../../../src/app/bi-reporting-config/syncwithcognos/syncwithcognos.component.html
// module chunks = main